<template>
  <div>
    <yxt-drawer
      :title="t('pc_comp_table_custom_drawer_title')"
      :visible.sync="showPanel"
      size="960px"
      custom-class="yxt-table__custom-drawer"
      :before-close="hidePanel"
      destroy-on-close
    >
      <div class="custom-column-box">
        <div class="custom-column-left" :style="leftStyle && leftStyle">
          <yxt-scrollbar :fit-height="true">
            <div class="custom-column-left-container">
              <div v-for="(group, index) in groupList" :key="index" :class="['group-list',group.NoColumn && 'group-no-list']" >
                <div v-if="group.NoColumn" class="group-item">
                  <yxt-checkbox
                    :disabled="group.disable"
                    @change="groupItemChange(group)"
                    v-model="group.checked"
                    >
                    <yxt-tooltip effect="dark" :open-filter="true" :content="group.name" placement="top">
                        <div class="item-text">{{ group.name }}</div>
                    </yxt-tooltip>
                    </yxt-checkbox
                  >
                  <yxt-tooltip
                    effect="dark "
                    :content="group.customColunmnDesc"
                    placement="top"
                    v-if="group.customColunmnDesc"
                    :max-width="440"
                  >
                    <yxt-svg
                      remote-url=""
                      class="color-gray-6 hover-primary-6"
                      width="16px"
                      :style="{
                        [RTLReplaceStyle('margin-left')]: '4px',
                        [RTLReplaceStyle('margin-right')]: '4px',
                      }"
                      style="cursor: pointer;"
                      height="16px"
                      icon-class="question-cirlce-o"
                    />
                  </yxt-tooltip>
                </div>
                <div v-else-if="group.list && group.list.length" class="group-item">
                  <div class="group-check-all" >
                    <yxt-checkbox
                      @change="groupChange(group)"
                      v-model="group.checkAll"
                      :indeterminate="group.isIndeterminate"
                      >
                        <yxt-tooltip effect="dark" :open-filter="true" :content="group.groupName " placement="top">
                          <div class="group-name-text">{{ group.groupName }}</div>
                        </yxt-tooltip>
                      </yxt-checkbox
                    >
                  </div>
                  <div class="item-list">
                    <div
                      class="item"
                      v-for="(item, index) in group.list"
                      :key="index"
                    >
                      <yxt-checkbox
                        :disabled="item.disable"
                        @change="groupItemChange(group)"
                        v-model="item.checked"
                        class="table_yxt-checkbox__input"
                        >
                          <yxt-tooltip effect="dark" :open-filter="true" :content="item.name" placement="top">
                            <div class="item-text">{{ item.name }}</div>
                          </yxt-tooltip>
                        </yxt-checkbox>
                      <yxt-tooltip
                        effect="dark "
                        :content="item.customColunmnDesc"
                        placement="top"
                        v-if="item.customColunmnDesc"
                        :max-width="440"
                      >
                        <yxt-svg
                          remote-url=""
                          class="color-gray-6 hover-primary-6"
                          width="16px"
                          :style="{
                            [RTLReplaceStyle('margin-left')]: '4px',
                            [RTLReplaceStyle('margin-right')]: '4px',
                          }"
                          style="cursor: pointer;"
                          height="16px"
                          icon-class="question-cirlce-o"
                        />
                      </yxt-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </yxt-scrollbar>
        </div>
        <div class="custom-column-right">
          <div class="choice-title">
            <span class="has-choice">{{t('pc_biz_flow_selected')}}：{{ checkedNum }}</span>
            <yxt-button type="text" size="small" @click="clearChoice"
              >{{ t('pc_comp_table_custom_clear') }}</yxt-button>
          </div>
          <div class="choice-detail" :style="rightStyle && rightStyle"   >
            <yxt-scrollbar :fit-height="true">
            <div class="list" v-for="(group, index) in groupList" :key="index"
              :draggable="!group.disableDrag"
              @dragstart.stop="(event) => handleDragStart(event, group, index)"
              @dragover.stop="(event) => handleDragOver(event, group, index,-1)"
              @dragleave.stop="(event) => handleDragLeave(event, group, index)"
              @dragend.stop="(event) => handleDragEnd(event, group, index)"
              @drop.stop="(event) => handleDrop(event, group, index)"
            >
            <!-- 未分组 -->
            <div v-if="group.NoColumn" :class="[(dragMoveState.gourpIndex === index && dragState.type==='group') && 'col-drag-over']" v-show="_showGroup(index)">
              <div class="group-head group-head-no-column">
              <div class="group-head-no-column-left">
              <yxt-tooltip v-if="isDragging && !group.disableDrag && !dragState.dragging" :open-filter="true" class="item" effect="dark" :content="t('pc_comp_table_columnCustomDragTip')" placement="top">
                <span class="custom-column-icon-drag color-gray-6 hover-primary-6"
                    @mousedown="(event) => handleCanDragStart(event, true,'group')"
                    @mouseup="(event) => handleCanDragStart(event, false, 'group')"
                  >
                  <yxt-svg width="16px" height="16px" icon-class="sort"/>
                </span>
              </yxt-tooltip>
               <!-- <div v-else style="width: 12px;"></div> -->
                <div class="group-name">
                  <yxt-tooltip effect="dark" :open-filter="true" :content="group.name " placement="top">
                    <div class="item-text">{{ group.name }}</div>
                  </yxt-tooltip>
                </div>
                </div>
                <div v-if="!group.disable" @click="delChoiceItem(group, -1)" class="group-item-close">
                  <yxt-svg
                    icon-class="common_close"
                    class="color-gray-8 hover-bg-gay-3 hand"
                    width="22px"
                    height="22px"
                  ></yxt-svg>
                </div>
              </div>
            </div>
            <div v-else  :class="[(dragMoveState.gourpIndex === index && dragState.type==='group') && 'col-drag-over']">
              <div class="group-head" v-show="_showGroup(index) && !group.NoColumn">
                <yxt-tooltip v-if="isDragging && !group.disableDrag && !dragState.dragging" :open-filter="true" class="item" effect="dark" :content="t('pc_comp_table_columnCustomDragTip')" placement="top">
                <span class="custom-column-icon-drag color-gray-6 hover-primary-6"
                  @mousedown="(event) => handleCanDragStart(event, true,'group')"
                  @mouseup="(event) => handleCanDragStart(event, false, 'group')"
                  >
                  <yxt-svg width="16px" height="16px" icon-class="sort"/>
                </span>
              </yxt-tooltip>
               <!-- <div v-else style="width: 12px;"></div> -->
                <div class="group-name">
                  <yxt-tooltip effect="dark" :open-filter="true" :content="group.groupName " placement="top">
                    <div class="item-text">{{ group.groupName }}</div>
                  </yxt-tooltip>
                </div>
              </div>
              <div
                class="group-item"
                :class="[(dragMoveState.gourpIndex === index && dragState.type==='item' && dragMoveState.itemIndex ===  itemI) && 'col-drag-over']"
                v-for="(item, itemI) in group.list"
                v-show="item.checked"
                :key="itemI"
               :draggable="!item.disableDrag"
               @dragstart.stop="(event) => handleDragStart(event, item, index,itemI)"
               @dragover.stop="(event) => handleDragOver(event, item, index,itemI)"
               @dragleave.stop="(event) => handleDragLeave(event, item, index)"
               @dragend.stop="(event) => handleDragEnd(event, item, index)"
               @drop.stop="(event) => handleDrop(event, item, index,itemI)"
              >
                <yxt-tooltip v-if="!item.disableDrag && isDragging && !dragState.dragging && !item.disable" :open-filter="true" class="item" effect="dark" :content="t('pc_comp_table_columnCustomDragTip')" placement="top">
                  <span class="custom-column-icon-drag color-gray-6 hover-primary-6"
                    @mousedown="(event) => handleCanDragStart(event, true,'item')"
                    @mouseup="(event) => handleCanDragStart(event, false,'item')"
                    >
                    <yxt-svg width="16px" height="16px" icon-class="sort"/>
                  </span>
                </yxt-tooltip>
                <div v-else-if='!item.disableDrag' style="width: 14px;"></div>
                 <yxt-tooltip
                  class="item"
                  :open-filter="true"
                  :content="item.name"
                  placement="top"
                >
                  <span class="item-text">{{ item.name }}</span>
                </yxt-tooltip>

                <div v-if="!item.disable" @click="delChoiceItem(group, itemI)" class="group-item-close">
                  <yxt-svg
                    icon-class="common_close"
                    class="color-gray-8 hover-bg-gay-3 hand"
                    width="22px"
                    height="22px"
                  ></yxt-svg>
                </div>
              </div>
            </div>
            </div>
            </yxt-scrollbar>
          </div>
        </div>
      </div>
      <div slot="footer" class="current-footer">
        <yxt-checkbox
          @change="checkoutAllChange"
          v-model="checkAll"
          :indeterminate="allIndeterminate"
          >{{ t('pc_comp_table_custom_check_all') }}</yxt-checkbox
        >
        <div>
          <yxt-button plain @click="hidePanel">{{t('pc_comp_table_cancel')  }}</yxt-button>
          <yxt-button type="primary" @click="changeCheckedList"
            >{{ t('pc_comp_table_confirm') }}</yxt-button
          >
        </div>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
import Locale from '@utils/mixins/locale';
import { RTLReplaceStyle, isInApaas } from '@utils/utils/util';
import { getLocalCacheObj, setLocalCacheObj, areColumnsEqual, isGroupListEqual } from './util';
// import { addClass, removeClass } from '@utils/utils/dom';

export default {
  mixins: [Locale],
  data() {
    return {
      drawer: true,
      checkAll: false,
      allIndeterminate: false,
      // 分组后的数据
      groupList: [],
      // 展示的列信息
      columnsList: [],
      disabledList: [],
      rightStyle: null,
      leftStyle: null,
      // 自定义列显示的列表
      checkedColumnsList: [],
      columnNums: 0,
      dragState: {
        draggingNode: null,
        dropNode: null,
        draggingIndex: 0,
        draggingItemIndex: 0,
        type: null,
        dragging: false
      },
      dragMoveState: {
        gourpIndex: -1,
        itemIndex: -1
      }
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    customColumnTop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkedNum() {
      let num = 0;
      this.groupList.forEach((group) => {
        if (group.NoColumn) {
          if (group.checked) {
            num = num + 1;
          }
        } else {
          num = num + group.list.filter((item) => item.checked).length;
        }

      });
      return num;
    },
    owner() {
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent;
    },
    cacheId() {
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent.customColumnProps.cacheId;
    },
    showPanel() {
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      if (this.customColumnTop) {
        return this.show;
      } else {
        if (parent.customColumnShow) {
          return true;
        }
        if (parent.store.states.showCustomColumnDrawer) {
          parent.customColumnShow = true;
          return true;
        } else {
          return false;
        }
      }
    },
    columnsOderMap() {
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent.store.states.columnsOderMap;
    },
    customColumnProps() {
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent.store.states.customColumnProps;
    },
    columnsGourpMap() {
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent.store.states.columnsGourpMap;
    },
    list() {
      let parent = this.$parent;
      return parent.customColumnProps.groupList || [];
    },
    isDragging() {
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent.store.states.customColumnProps.isDragable;
    }
  },
  methods: {
    RTLReplaceStyle,
    hidePanel() {
      this.owner.store.states.showCustomColumnDrawer = false;
      this.owner.store.toggleCustomColumnPanelShow();
      this.$emit('closeDrawer');
      this.reset();
    },
    // 分组拖拽开始
    handleDragStart(event, column, index, itemIndex) {
      if (!this.dragState.canDrag) {
        event.preventDefault();
        return;
      }

      event.dataTransfer.effectAllowed = 'move';
      // wrap in try catch to address IE's error when first param is 'text/plain'
      try {
        // setData is required for draggable to work in FireFox
        // the content has to be '' so dragging a node out of the tree won't open a new tab in FireFox
        event.dataTransfer.setData('text/plain', '');
      } catch (e) { }
      // document.body.style.cursor = 'grabbing';

      const originIndex = column.originIndex;
      this.dragState.dragging = true;
      this.dragState.draggingNode = column;
      this.dragState.draggingIndex = originIndex;
      this.dragState.draggingShowIndex = index;
      this.dragState.draggingItemIndex = itemIndex;
    },

    handleDragLeave(event, column, index) {
      this.setDragRow();
    },
    setDragRow(itemIndex, GroupIndex, states = false) {
      if (!states) {
        this.dragMoveState.gourpIndex = -1;
        this.dragMoveState.itemIndex = -1;
      } else {
        if (this.dragState.type === 'group') {
          if (this.dragState.draggingShowIndex === GroupIndex) return;
          if (this.dragState.draggingShowIndex > GroupIndex && GroupIndex > 0) GroupIndex--;
          this.dragMoveState.gourpIndex = GroupIndex;
          this.dragMoveState.itemIndex = -1;
        } else {
          this.dragMoveState.gourpIndex = GroupIndex;
          if (this.dragState.draggingItemIndex === itemIndex) return;
          if (this.dragState.draggingItemIndex > itemIndex && itemIndex > 0) itemIndex--;
          this.dragMoveState.itemIndex = itemIndex;
        }
      }
    },

    handleDrop(event, column, targetGroupIndex, targetItemIndex) {
      this.setDragRow();

      if (!this.dragState.dragging) return;
      if (this.dragState.type === 'item') {
        const sourceGroupIndex = this.dragState.draggingShowIndex;
        const sourceItemIndex = this.dragState.draggingItemIndex;

        // 检查是否同组
        if (sourceGroupIndex !== targetGroupIndex) return;

        // 设置分组内联动
        const group = [...this.groupList[sourceGroupIndex].list];
        const [removed] = group.splice(sourceItemIndex, 1);
        group.splice(targetItemIndex, 0, removed);
        this.$set(this.groupList[sourceGroupIndex], 'list', group);

      } else if (this.dragState.type === 'group') {
        const sourceIndex = this.dragState.draggingShowIndex;

        const groups = [...this.groupList];
        const [removed] = groups.splice(sourceIndex, 1);
        groups.splice(targetGroupIndex, 0, removed);
        this.groupList = groups;
      }
    },

    // 项目拖拽悬停处理
    handleDragOver(event, column, index, itemI) {
      // 禁止拖拽到 组 拖到 分组内 ，则不允许拖拽
      if (this.dragState.type === 'group' && itemI !== -1) {
        document.body.style.cursor = 'no-drop';
        return;
      };
      // 如果 禁止拖拽，则不允许拖拽
      if (column.disableDrag || column.disable) {
        document.body.style.cursor = 'no-drop';
        return;
      }
      this.setDragRow(itemI, index, true);
      document.body.style.cursor = 'grabbing';
      event.preventDefault();
    },

    handleDragEnd(event, column, index) {
      this.dragState.canDrag = false;
      this.dragState.dragging = false;
      this.dragState.draggingNode = null;
      this.dragState.draggingIndex = null;
      this.dragState.type = null;
      document.body.style.cursor = '';
    },
    // 分组内联动
    groupChange(obj) {
      if (obj.checkAll) {
        obj.list.forEach((item) => {
          obj.isIndeterminate = false;
          if (!item.disable) {
            item.checked = true;
          }
        });
      } else {
        obj.list.forEach((item) => {
          if (!item.disable) {
            item.checked = false;
          }
          obj.isIndeterminate = false;
        });
      }
      // 联动所有全选
      this.updataAllCheckoutStatus();
    },
    // 点击确定
    groupItemChange(obj) {
      // 联动所有全选
      this.updataAllCheckoutStatus();
    },
    updataAllCheckoutStatus() {
      // 分组内全选按钮状态联动
      this.groupList.forEach((obj) => {
        if (obj.NoColumn) return;
        const checkNum = obj.list.filter((item) => item.checked).length;
        if (checkNum === obj.list.length) {
          obj.checkAll = true;
          obj.isIndeterminate = false;
        } else if (checkNum > 0 && checkNum < obj.list.length) {
          obj.isIndeterminate = true;
          obj.checkAll = false;
        } else {
          obj.checkAll = false;
          obj.isIndeterminate = false;
        }
      });
      // 全局全选按钮状态联动
      const itemsCheckAllLenth = this.groupList.filter((item) => {
        return item.NoColumn ? item.checked : item.checkAll;
      }).length;
      if (itemsCheckAllLenth === this.groupList.length) {
        this.checkAll = true;
        this.allIndeterminate = false;
      } else if (
        itemsCheckAllLenth > 0 &&
        itemsCheckAllLenth < this.groupList.length
      ) {
        this.allIndeterminate = true;
        this.checkAll = false;
      } else {
        this.checkAll = false;
        const isIndeterminateLenth = this.groupList.filter((item) => item.isIndeterminate);
        if (isIndeterminateLenth) {
          this.allIndeterminate = true;
        } else {
          this.allIndeterminate = false;
        }
      }
    },

    changeCheckedList() {
      // 搜集所有选中的列
      const checkedColumnsList = [];
      this.groupList.forEach((item) => {
        if (item.NoColumn) {
          item.checked && checkedColumnsList.push(item.name);
        } else {
          item.list.forEach((a) => {
            if (a.checked) {
              checkedColumnsList.push(a.name);
            }
          });
        };
      });
      this.checkedColumnsList = checkedColumnsList;
      this.owner.store.updateColumnsChecked(
        this.checkedColumnsList.concat(this.disabledList)
      );
      // 更新排序
      this.updataColumnsOderMap();
      this.owner.reload(false);
      this.hidePanel();
      // 设置缓存
      this.setCacheObj();
    },
    // 更新排序
    updataColumnsOderMap() {
      let columnsOderMap = JSON.parse(JSON.stringify(this.columnsOderMap));
      const columnsGourpMap = {}; // 分组排序
      const newMap = []; // 重新排序后的map
      this.groupList.forEach((item) => {
        if (item.NoColumn) {
          newMap.push({
            index: item.index,
            originIndex: item.originIndex
          });
          columnsGourpMap[item.name] = [];
        } else {
          columnsGourpMap[item.groupName] = [];
          item.list.forEach((a) => {
            columnsGourpMap[item.groupName].push(a.name);
            newMap.push({
              index: a.index,
              originIndex: a.originIndex
            });
          });
        };
      });
      // 排序
      const sortMap = JSON.parse(JSON.stringify(newMap)).sort((a, b) => a.originIndex - b.originIndex);
      // // 处理originIndex
      newMap.forEach((item, i) => {
        item.originIndex = sortMap[i].originIndex;
      });
      // 赋值
      newMap.forEach((item) => {
        columnsOderMap[item.index] = item.originIndex;
      });
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      parent.store.states.columnsOderMap = columnsOderMap;
      parent.store.states.columnsGourpMap = columnsGourpMap;
    },
    setCacheObj() {
      if (!this.cacheId) return false;
      const cacheObj = {
        columnsOderMap: this.columnsOderMap,
        checkedColumnsList: this.checkedColumnsList,
        columnsGourpMap: this.columnsGourpMap,
        groupList: this.list,
        columnsList: this.owner.customColumns,
        isDrawer: this.customColumnProps.isDrawer,
        showDiasbledAttributes: this.customColumnProps.showDiasbledAttributes
      };
      setLocalCacheObj(this.cacheId, cacheObj);
    },
    getCacheObj() {
      if (!this.cacheId) return false;
      const customCacheStr = getLocalCacheObj(this.cacheId);
      if (!customCacheStr) return false;
      const cacheObj = JSON.parse(customCacheStr);
      if (!cacheObj) return false;
      // 判断表头是否发生了变化，如果变化，则不加载缓存
      // 判断 groupList 是否发生变化，如果变化，则不加载缓存
      if (this.customColumnProps.isDrawer !== cacheObj.isDrawer) return;
      if (this.customColumnProps.showDiasbledAttributes !== cacheObj.showDiasbledAttributes) return;
      if (!areColumnsEqual(this.owner.customColumns, cacheObj.columnsList) || !isGroupListEqual(this.list, cacheObj.groupList)) {
        return false;
      }
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      parent.store.states.columnsOderMap = cacheObj.columnsOderMap; // 排序
      this.checkedColumnsList = cacheObj.checkedColumnsList; // 勾选
      parent.store.states.columnsGourpMap = cacheObj.columnsGourpMap || {}; // 分组
      return true;
    },
    checkoutAllChange() {
      if (this.checkAll) {
        this.groupList.forEach((item) => {
          if (item.NoColumn) {
            (!item.disable) && (item.checked = true);
          } else {
            item.checkAll = true;
            item.isIndeterminate = false;
            item.list.forEach((item) => {
              if (!item.disable) {
                item.checked = true;
              }
            });
          };
        });
      } else {
        this.groupList.forEach((item) => {
          if (item.NoColumn) {
            (!item.disable) && (item.checked = false);
          } else {
            item.checkAll = false;
            item.isIndeterminate = false;
            item.list.forEach((item) => {
              if (!item.disable) {
                item.checked = false;
              }
            });
          }
        });
      }
      this.updataAllCheckoutStatus();
    },
    clearChoice() {
      // fix:清空第一次点击不生效问题
      setTimeout(() => {
        this.groupList.forEach((item) => {
          if (item.NoColumn) {
            (!item.disable) && (item.checked = false);
            return true;
          };
          item.checkAll = false;
          item.isIndeterminate = false;
          item.list.forEach((item) => {
            if (!item.disable) {
              item.checked = false;
            }
          });
        });
        this.updataAllCheckoutStatus();
      });
    },
    delChoiceItem(obj, index) {
      if (index === -1) {
        obj.checked = false;
      } else {
        obj.list.forEach((item, idx) => {
          if (idx === index) {
            item.checked = false;
          }
        });
      }
      if (!obj.NoColumn) {
        const checkNum = obj.list.filter((item) => item.checked).length;
        if (checkNum === obj.list.length) {
          obj.checkAll = true;
          obj.isIndeterminate = false;
        } else if (checkNum > 0 && checkNum < obj.list.length) {
          obj.isIndeterminate = true;
        } else {
          obj.checkAll = false;
          obj.isIndeterminate = false;
        }
      }

      // 更新全局全选按钮状态
      this.updataAllCheckoutStatus();
    },
    _showGroup(index) {
      if (this.groupList[index].NoColumn) {
        return this.groupList[index].checked || false;
      }
      const groupLen = this.groupList[index].list.filter((item) => item.checked).length || 0;
      if (groupLen === 0) {
        return false;
      }
      return true;
    },

    getCustomColumnList(haveCache = false) {
      // console.log('getCustomColumnList +++++++++++');
      let customColumns = [];
      this.columnsList = [];
      this.disabledList = [];
      !haveCache && (this.checkedColumnsList = []);

      const orderedList = [];
      // 处理删除的
      for (let key in this.owner.customColumns) {
        const column = this.owner.customColumns[key];
        if (column.deleted) {
          for (let key2 in this.owner.customColumns) {
            const c = this.owner.customColumns[key2];
            if (c.index > column.index && !column.reseted && !column.deleted) {
              c.index = c.index - 1; // 删除的元素后的序号归位
            }
          }
        }
      }

      // 处理排序
      let index = 0;
      for (let key in this.owner.customColumns) {
        const column = this.owner.customColumns[key];
        column.reseted = true;
        if (!column.deleted) {
          let newIndex = column.index;
          if (this.columnsOderMap[newIndex] !== undefined) {
            newIndex = this.columnsOderMap[newIndex];
            column.originIndex = newIndex;
            orderedList[newIndex] = column;

            index++;
          }
        }
      }
      this.columnNums = index;
      // console.log(orderedList);
      // console.log(this.columnsOderMap);
      // console.log(this.owner.customColumns);
      // console.log(Object.values(this.owner.customColumns).map((c) => c.label));
      // console.log(orderedList.map((c) => c.label));

      // 处理禁用隐藏
      if (
        this.owner.customColumnProps &&
        !this.owner.customColumnProps.showDiasbledAttributes
      ) {
        orderedList.forEach((column, index) => {
          // 判断disable=true ，且在分组内， 如果在分组内则禁用显示
          if (column.disable && !this._isInList(column.label)) {
            this.disabledList.push(column.label);
          } else {
            customColumns.push(column);
          }
        });
      } else {
        customColumns = orderedList;
      }

      customColumns.forEach((column, index) => {
        // label 为空的不显示
        if (!column.label && column.type === 'default') {
          return;
        }
        this.columnsList.push(column);
        if (!column.hide && !haveCache) {
          this.checkedColumnsList.push(column.label);
        }
      });
      this.owner.fixedColumns &&
        this.owner.fixedColumns.forEach((oc) => {
          const cl = this.columnsList.find((c) => oc.label === c.label);
          if (cl) cl.disableDrag = true;
        });
      this.owner.rightFixedColumns &&
        this.owner.rightFixedColumns.forEach((oc) => {
          const cl = this.columnsList.find((c) => oc.label === c.label);
          if (cl) cl.disableDrag = true;
        });
      this.getGroupList();
    },
    //  是否在分组内
    _isInList(label) {
      let status = false;
      if (!this.list.length) {
        status = false;
        return status;
      }
      this.list.forEach((item) => {
        if (item.list.find((c) => c.name === label)) {
          status = true;
        }
      });
      return status;
    },
    getGroupList() {
      let groupList = [];
      if (this.list.length === 0) {
        const currentList = [];

        this.columnsList.forEach((column) => {
          if (column.label) {
            currentList.push({
              name: column.label,
              NoColumn: true, // 无分组
              disable: column.disable || false,
              customColunmnDesc: (column && column.customColunmnDesc) || '',
              disableDrag: column.disableDrag || false,
              originIndex: column.originIndex,
              index: column.index,
              checked: this.checkedColumnsList.includes(column.label)
            });
          }
        });
        groupList = currentList;
      } else {
        // 是否是apass 应用
        const isApass = isInApaas();
        // 获取分组列
        this.list.forEach((item) => {
          const currentList = [];
          let groupIsDragable = item.isDragable || false;
          const itemList = item.list || [];
          itemList.forEach((group) => {
            let column = this.columnsList.find((c) => c.label === group.name);
            // 如果 showDiasbledAttributes ，同时分组内设置了该列，则默认禁用展示
            let defaultDisable = false;
            if (!column && this.disabledList.find((c) => c === group.name)) {
              defaultDisable = true;
            }
            if (column && column.disableDrag) {
              groupIsDragable = false;
            }
            // 避免设置的并不存在的列
            if (column) {
              currentList.push({
                name: group.name,
                disable: (column && column.disable) || defaultDisable,
                customColunmnDesc: (column && column.customColunmnDesc) || '',
                checked:
                  this.checkedColumnsList.includes(group.name) || defaultDisable,
                index: column.index,
                originIndex: column.originIndex,
                disableDrag: !isApass
              });
            }
          });
          groupList.push({
            groupName: item.groupName,
            checkAll: false,
            isIndeterminate: false,
            disableDrag: !groupIsDragable, // 分组默认禁止拖拽
            list: currentList
          });
        });
        // 获取不分组列
        const NoColumns = this.getNoColumns();
        if (NoColumns && NoColumns.length) {
          groupList.push(...NoColumns);
        }
      }
      // 如果有分组排序，则按照分组排序
      const groupKeys = Object.keys(this.columnsGourpMap);
      if (groupKeys.length) {
        const newGroupList = [];
        groupKeys.forEach((GroupName) => {
          const groupItem = groupList.find((item) => {
            const name = item.NoColumn ? item.name : item.groupName;
            return name === GroupName;
          });
          if (!groupItem.NoColumn && groupItem.list && groupItem.list.length) {
            if (this.columnsGourpMap[GroupName].length) {
              const newList = [];
              this.columnsGourpMap[GroupName].forEach((name) => {
                const item = groupItem.list.find((c) => c.name === name);
                item && newList.push(item);
              });
              groupItem.list = newList;
            }
          }
          groupItem && newGroupList.push(groupItem);
        });
        groupList = newGroupList;
      }
      this.groupList = groupList;
      this.updataAllCheckoutStatus();
    },
    getNoColumns() {
      const list = [];
      const allGroupItems = [];
      this.list.forEach((item) => {
        if (item.list && item.list.length) {
          item.list.forEach((group) => {
            allGroupItems.push(group.name);
          });
        }
      });
      this.columnsList.forEach((column) => {
        const GroupItem = allGroupItems.find((name) => column.label === name);
        if (!GroupItem && column && column.label) {
          list.push({
            name: column.label,
            disable: column.disable || false,
            customColunmnDesc: (column && column.customColunmnDesc) || '',
            NoColumn: true, // 无分组
            disableDrag: true, // 未分组禁止拖拽
            originIndex: column.originIndex,
            index: column.index,
            checked: this.checkedColumnsList.includes(column.label)
          });
        }
      });
      return list;
    },
    setScrollHeight() {
      this.rightStyle = null;
      this.leftStyle = null;
      var windowHeight = window.innerHeight;
      this.rightStyle = {
        height: windowHeight - 190 + 'px'
      };
      this.leftStyle = {
        height: windowHeight - 148 + 'px'
      };
    },
    handleCanDragStart(event, isStart, type) {
      this.dragState.canDrag = isStart;
      if (isStart) {
        this.dragState.type = type;
      } else {
        this.dragState.type = '';
      }
    },

    reset() {
      // console.log('reset =====');
      this.data = {
        // 展示的列信息
        columnsList: [],
        // 自定义列显示的列表
        checkedColumnsList: [],
        // 全选状态
        checkAll: false,
        // 表示 checkbox 的不确定状态，用于实现全选的效果
        allIndeterminate: true,
        // 被禁用项的列表
        disabledList: [],
        groupList: []
      };
    }
  },
  watch: {
    showPanel: {
      handler(val) {
        // console.log('watch show Panel =====', val);
        if (!val) {
          this.reset();
        } else {
          if (this.cacheId) {
            // 获取缓存
            const haveCache = this.getCacheObj();
            this.getCustomColumnList(haveCache);
            if (!haveCache) {
              this.setCacheObj();
            }
          } else {
            this.getCustomColumnList();
          }

          this.setScrollHeight();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('resize', this.setScrollHeight);
  },
  destroyed() {
    window.removeEventListener('resize', this.setScrollHeight);
  }
};
</script>
